/**
 * Frances Design — Scroll Header
 *
 * 1. Adds 'fd-scrolled' to <html> after SCROLL_THRESHOLD px.
 *    CSS in fd-brand-styles.liquid then switches the header to a cream/paper
 *    background with charcoal links and swaps to the dark logo.
 * 2. Injects font-size/family CSS directly into shopify-account shadow DOM.
 * 3. Syncs the cart count bubble to .fd-cart-count spans.
 */
(function () {
  'use strict';

  /* ============================================================
     1. Scroll threshold → sticky charcoal header
  ============================================================ */
  var SCROLL_THRESHOLD = 500;
  var html = document.documentElement;
  var ticking = false;

  function update() {
    html.classList.toggle('fd-scrolled', window.scrollY > SCROLL_THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update(); // set initial state (handles back-navigation to mid-page)

  /* ============================================================
     2. shopify-account shadow DOM font fix
     The web component renders an internal button in shadow DOM at
     browser-default (16px / Inter). We inject a <style> directly
     into the open shadow root — the only reliable way to reach it.
  ============================================================ */
  var STYLE_ID = 'fd-account-fix';
  var FIX_CSS = [
    ':host {',
    '  --header-actions-font-family: "Alvar Essential", "Inter", system-ui, sans-serif !important;',
    '}',
    'button, a, span {',
    '  font-size: 0.6875rem !important;',
    '  font-family: "Alvar Essential", "Inter", system-ui, sans-serif !important;',
    '  letter-spacing: 0.22em !important;',
    '  text-transform: uppercase !important;',
    '  line-height: 1 !important;',
    '  font-weight: 400 !important;',
    '  color: inherit !important;', /* inherits from host — charcoal in scrolled state */
    '}'
  ].join('\n');

  function injectIntoHost(host) {
    var root = host.shadowRoot;
    if (!root) return false;
    if (root.getElementById(STYLE_ID)) return true; // already done
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = FIX_CSS;
    root.appendChild(style);
    return true;
  }

  function injectAll() {
    var hosts = document.querySelectorAll('.account-button--text shopify-account');
    var done = 0;
    hosts.forEach(function (host) {
      if (injectIntoHost(host)) done++;
    });
    return done === hosts.length && hosts.length > 0;
  }

  // Poll until shadow root is available (component upgrades asynchronously)
  function pollUntilReady() {
    var attempts = 0;
    var MAX = 80; // up to 4 seconds at 50ms intervals

    function tick() {
      attempts++;
      if (injectAll()) return; // success — stop polling
      if (attempts < MAX) setTimeout(tick, 50);
    }

    tick();
  }

  // Start polling as soon as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pollUntilReady);
  } else {
    pollUntilReady();
  }

  // Also fire after component is defined (belt-and-suspenders)
  if (typeof customElements !== 'undefined' && customElements.whenDefined) {
    customElements.whenDefined('shopify-account').then(function () {
      setTimeout(pollUntilReady, 100);
    });
  }

  /* ============================================================
     3. Cart count sync
     Horizon updates .cart-bubble__text-count via JS.
     We watch that element and mirror the value to every
     .fd-cart-count span so "YOUR BAG (n)" stays accurate.
  ============================================================ */
  function syncCartCounts() {
    var bubble = document.querySelector('.cart-bubble__text-count');
    var countEls = document.querySelectorAll('.fd-cart-count');
    if (!bubble || !countEls.length) return;

    function update() {
      var n = bubble.textContent.trim();
      countEls.forEach(function (el) { el.textContent = n; });
    }

    update(); // initial sync on load

    new MutationObserver(update).observe(bubble, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartCounts);
  } else {
    syncCartCounts();
  }
})();
